<template>
  <div class="mb-8">
    <div class="flex justify-end items-center gap-4">
      <img src="../assets/images/stopwatch.png" alt="woods" class="h-6 w-6" />
      <LiteCountDownTimer :targetDate="endPunlicationDate" />
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4 w-full py-2 lg:py-4">
      <div
        v-for="bonusQuest in bonusQuests"
        :key="bonusQuest.id"
        :class="{
          'p-4 rounded bg-neutral-800 flex flex-col gap-2 justify-between lg:justify-start transition-all': true,
          'bg-primary bg-opacity-40': bonusQuest.claim,
        }"
      >
        <div class="flex gap-4 h-10 justify-between items-center">
          <Typography size="main-md" class="!text-2xl lg:!text-3xl">{{ bonusQuest.title }}</Typography>
          <span class="flex gap-2 items-center justify-center h-12">
            <img
              src="../assets/images/stopwatch.png"
              alt="woods"
              class="h-6 w-6"
              v-if="!bonusQuest.fixed"
            />
            <img src="~/assets/svg/troncos.svg" alt="woods" class="h-6 w-6" />
            <Typography size="main-l-num">{{ bonusQuest.logs }}</Typography>
          </span>
        </div>
        <div class="flex flex-col lg:flex-row flex-1 justify-between lg:justify-between gap-2 lg:gap-2">
          <Typography size="secondary-sm">{{
            bonusQuest.description
          }}</Typography>
          <button
            v-if="
              bonusQuest.claim == false &&
              bonusQuest.verify == false &&
              bonusQuest.readyToClaim == false
            "
            class="h-12 min-w-36 rounded border border-primary hover:bg-primary transition-all"
            @click="completeQuest(bonusQuest)"
            :disabled="isSubmitting"
            :class="{
              'bg-primary bg-opacity-40': isSubmitting,
            }"
          >
            <Typography size="main-sm">{{ bonusQuest.ctaButton }}</Typography>
          </button>
          <button
            v-if="bonusQuest.claim == true && bonusQuest.readyToClaim == false && bonusQuest.type !== 'do_not_click'"
            class="h-12 min-w-36 font-bold flex gap-2 text-primary items-center justify-center"
            :disabled="isSubmitting"
            :class="{
              'bg-primary bg-opacity-40': isSubmitting,
            }"
          >
            <Typography size="main-l">Claimed</Typography>
            <img src="~/assets/svg/claimed.svg" alt="woods" class="h-5 w-5" />
          </button>
          <button
            v-if="bonusQuest.claim == true && bonusQuest.readyToClaim == false && bonusQuest.type === 'do_not_click'"
            class="h-12 min-w-36 font-bold flex gap-2 text-primary items-center justify-center"
            :disabled="isSubmitting"
            :class="{
              'bg-primary bg-opacity-40': isSubmitting,
            }"
          >
            <Typography size="main-l">Infected</Typography>
            <img src="~/assets/svg/claimed.svg" alt="woods" class="h-5 w-5" />
          </button>
          <button
            v-if="bonusQuest.verify == true && bonusQuest.readyToClaim == false"
            class="h-12 min-w-36 font-bold flex gap-2 text-primary items-center justify-center"
            :disabled="true"
            :class="{
              'bg-primary bg-opacity-40': isSubmitting,
            }"
          >
            <Typography size="main-l">Verifying</Typography>
            <img src="~/assets/svg/claimed.svg" alt="woods" class="h-5 w-5" />
          </button>
          <button
            v-if="bonusQuest.readyToClaim == true && bonusQuest.claim == false"
            @click="claimQuest(bonusQuest)"
            class="h-12 min-w-36 rounded bg-primary font-bold items-center justify-center flex"
            :disabled="isSubmitting"
            :class="{
              'bg-primary bg-opacity-40': isSubmitting,
            }"
          >
            <span v-if="bonusQuest.type === 'get_discord_role'">
              <Typography size="main-md">Verify</Typography>
            </span>
            <span v-else class="flex gap-2 items-center">
              <Typography size="main-md">Claim </Typography>
              <img src="~/assets/svg/troncos.svg" alt="woods" class="h-4 w-4" />
              <Typography size="main-md-num">{{ bonusQuest.logs }}</Typography>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import Typography from "../components/common/Typography.vue";
import { cmsStore } from "../stores/cmsStore";
import LiteCountDownTimer from "./lite-count-down-timer.vue";

const cms = cmsStore();

const endPunlicationDate = computed(() => {
  const lastBonusQuestIdx = cms.bonusQuests.length - 1;
  return cms.bonusQuests[lastBonusQuestIdx].end_publication_date;
});

const props = defineProps({
  bonusQuests: Array,
  isSubmitting: Boolean,
});

const emit = defineEmits(["completeQuest", "claimQuest"]);

function claimQuest(quest) {
  emit("claimQuest", quest);
}

function completeQuest(quest) {
  emit("completeQuest", quest);
}
onMounted(() => {
  console.log(props.bonusQuests);
});
</script>
